// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const PageLinkFragmentDoc = gql`
    fragment pageLink on Page {
  id
  path
}
    `;
export const PostLinkFragmentDoc = gql`
    fragment postLink on Post {
  id
  slug
}
    `;
export const CustomLinkFragmentDoc = gql`
    fragment customLink on LinkItemCustom {
  url
}
    `;
export const LinkQuestionnaireFragmentDoc = gql`
    fragment linkQuestionnaire on Questionnaire {
  id
}
    `;
export const LinkItemOpenEnquiryFormFragmentDoc = gql`
    fragment linkItemOpenEnquiryForm on LinkItemOpenEnquiryForm {
  enquiryType
}
    `;
export const LinkItemErRecommendationsFragmentDoc = gql`
    fragment linkItemErRecommendations on LinkItemEngagementRingRecommendations {
  __typename
  recommendations {
    designFeature {
      systemCode
    }
    designStyle {
      systemCode
    }
    metal {
      systemCode
    }
    ringStyle {
      systemCode
    }
    shape {
      systemCode
    }
  }
}
    `;
export const LinkItemFragmentDoc = gql`
    fragment linkItem on LinkItem {
  __typename
  ...pageLink
  ...postLink
  ...customLink
  ...linkQuestionnaire
  ...linkItemOpenEnquiryForm
  ...linkItemErRecommendations
}
    ${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}`;
export const LinkFragmentDoc = gql`
    fragment link on Link {
  text
  target
  item {
    ...linkItem
  }
}
    ${LinkItemFragmentDoc}`;
export const LinkDesignStudioProductFragmentDoc = gql`
    fragment linkDesignStudioProduct on DesignStudioProduct {
  id
}
    `;
export const LinkOrderFragmentDoc = gql`
    fragment linkOrder on Order {
  id
}
    `;